import { useAuth } from "../../../../../../features/auth/context";
import { useOrgSiteContext } from "../../../../../../hooks/useOrgSiteContext";

export function useEffectiveOrgId(
    boxOrgId: number | undefined,
): number {
    const { orgId: contextOrgId } = useOrgSiteContext("boxDetail");
    const { orgId: assignedOrgId } = useAuth();

    return boxOrgId || contextOrgId || assignedOrgId || 0;
}
